module.exports = __webpack_public_path__ + "static/media/exclamation-dark.daef534c.svg";